import { Box, SxProps, useTheme } from "@mui/material";
import EdmSaveButton from "atoms/Buttons/EdmSaveButton";
import { MouseEvent, ReactElement } from "react";
import { SaveButtonProps, Toolbar } from "react-admin";
import { FieldValues, SubmitHandler } from "react-hook-form";

export type DefaultToolbarPropsType = {
  additionalButtons?: ReactElement;
  saveButtonIcon?: ReactElement;
  saveButtonLabel?: string;
  saveButtonColor?: SaveButtonProps["color"];
  type?: "submit" | "reset" | "button" | undefined;
  alwaysEnableSaveButton?: boolean;
  inline?: boolean;
  saveButtonTestSelector?: string;
  transparent?: boolean;
  deleteButton?: ReactElement;
  pristine?: boolean;
  mutationOptions?: SaveButtonProps["mutationOptions"];
  sx?: SxProps;
  resource?: string;
  onSubmit?: SubmitHandler<FieldValues>;
  disabled?: boolean;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
};

export default function DefaultToolbar(props: DefaultToolbarPropsType) {
  const {
    additionalButtons,
    saveButtonIcon,
    saveButtonLabel,
    saveButtonColor,
    saveButtonTestSelector,
    transparent = true,
    deleteButton = null,
    inline = false,
    alwaysEnableSaveButton,
    pristine,
    mutationOptions,
    type = "submit",
    resource,
    sx,
    disabled = false,
    onSubmit,
    onClick,
  } = props;

  const theme = useTheme();

  const finalSx = {
    mt: 0,
    ...(transparent && {
      backgroundColor: "transparent",
    }),
    ...(inline && {
      minHeight: theme.mixins.toolbar.minHeight,
      height: theme.mixins.toolbar.minHeight,
    }),
    ...sx,
  };

  const calculatedDisabled = disabled || ((alwaysEnableSaveButton ? false : pristine) as boolean);

  return (
    <Toolbar sx={finalSx}>
      {additionalButtons}
      <EdmSaveButton
        onSubmit={onSubmit}
        resource={resource}
        type={type}
        data-testid={saveButtonTestSelector}
        disabled={calculatedDisabled}
        icon={saveButtonIcon}
        label={saveButtonLabel}
        color={saveButtonColor}
        mutationOptions={mutationOptions}
        alwaysEnable={!disabled && alwaysEnableSaveButton}
        onClick={onClick}
      />
      {deleteButton && <Box ml={2}>{deleteButton}</Box>}
    </Toolbar>
  );
}
